(function (algolia) {
  "use strict";

  // const { autocomplete, getAlgoliaResults } = window['@algolia/autocomplete-js'];
  // const { createQuerySuggestionsPlugin } = window['@algolia/autocomplete-plugin-query-suggestions'];
  // const { createAlgoliaInsightsPlugin } = window['@algolia/autocomplete-plugin-algolia-insights'];
  // const { createInsightsMiddleware } = window.instantsearch.middlewares;
  

  algolia.externals = {
    // Export the required librarires
    instantsearch: window.instantsearch,
    algoliasearch: window.algoliasearch,
    // autocomplete,
    // getAlgoliaResults,
    // createAlgoliaInsightsPlugin,
    // createQuerySuggestionsPlugin,
    // createInsightsMiddleware,
    // insightsClient: window.aa,
    html: window.preact.h,
    render: window.preact.render,

    // Export the required widgets
    widgets: {
      rangeSlider: window.instantsearch?.widgets.rangeSlider,
      menu: window.instantsearch?.widgets.menu,
      refinementList: window.instantsearch?.widgets.refinementList,
      toggleRefinement: window.instantsearch?.widgets.toggleRefinement,
      searchBox: window.instantsearch?.widgets.searchBox,
      stats: window.instantsearch?.widgets.stats,
      sortBy: window.instantsearch?.widgets.sortBy,
      clearRefinements: window.instantsearch?.widgets.clearRefinements,
      panel: window.instantsearch?.widgets.panel,
      hits: window.instantsearch?.widgets.hits,
      pagination: window.instantsearch?.widgets.pagination,
      configure: window.instantsearch?.widgets.configure,
      // Define any new widgets here...
      infiniteHits: instantsearch?.widgets.infiniteHits,
      dymamicWidgets: instantsearch?.widgets.dynamicWidgets,
    },

    // Export InstantSearch connectors
    connectors: {
      connectCurrentRefinements:
      instantsearch.connectors.connectCurrentRefinements,
      connectRange: instantsearch.connectors.connectRange,
      connectRefinementList: instantsearch.connectors.connectRefinementList,
      connectSortBy: instantsearch.connectors.connectSortBy,
    },
  };
})(window.algoliasearch);